import ipoNavigationRoutes from "./navigationRoutes";
import IPOHomePage from "../pages/Home/IPOHomePage";
import IPOApplicationStatusPage from "../pages/IPOApplicationStatusPage";
import IPODetailsPage from "../pages/IPODetailsPage";

// Public routes that don't require authentication
const publicRoutes = [
  {
    path: ipoNavigationRoutes.IPO_HOME,
    element: IPOHomePage,
    name: "IPO Home",
  },
  {
    path: ipoNavigationRoutes.IPO_DETAILS,
    element: IPODetailsPage,
    name: "IPO Details",
  },
];

// Auth routes that require authentication
const authRoutes: Array<{
  path: string;
  element: React.ComponentType;
  name: string;
}> = [
  {
    path: ipoNavigationRoutes.IPO_APPLICATION_STATUS,
    element: IPOApplicationStatusPage,
    name: "IPO Application Status",
  },
];

// Main routes configuration
const routes = [
  {
    type: "auth",
    routes: authRoutes,
  },
  {
    type: "public",
    routes: publicRoutes,
  },
];

export default routes;
